import { useSelector } from 'react-redux'

function SubmitModalButton({ text, customFn, disabled, form, icon, loading }) {
  const languageRedux = useSelector(
    (state) => state.language?.language?.data?.general
  )

  const language = languageRedux || {}

  return (
    <button
      {...(form !== undefined ? { form } : {})}
      {...(disabled !== undefined ? { disabled } : {})}
      type='submit'
      className='btn btn-info mr-1'
      onClick={() => customFn && customFn()}
    >
      {icon ? icon : null} {text ? text : language.save}{' '}
      {loading ? (
        <span className='spinner-border spinner-border-sm'></span>
      ) : null}
    </button>
  )
}

export default SubmitModalButton
